var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "maint-summary-scroll" }, [
    !_vm.hasSelectedUnit
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger text-center",
            attrs: { role: "alert" },
          },
          [_c("h2", [_vm._v(_vm._s(_vm.$t("pleaseSelectUnit")))])]
        )
      : _vm._e(),
    _vm.hasSelectedUnit
      ? _c(
          "div",
          { staticClass: "container maintsummary summary mt-3 pl-0 pr-0" },
          [
            _c("loading", {
              attrs: { active: _vm.loading, "can-cancel": false },
              on: {
                "update:active": function ($event) {
                  _vm.loading = $event
                },
              },
            }),
            !_vm.data.selected.unit
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-danger text-center",
                    attrs: { role: "alert" },
                  },
                  [
                    _c("h2", { staticClass: "text-danger" }, [
                      _vm._v(" " + _vm._s(_vm.$t("pleaseSelectUnit")) + " "),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.data.navBarRefresh == false &&
            _vm.data.selected.unit !== undefined &&
            _vm.data.selected.unit !== null
              ? _c("div", { staticClass: "pl-0 pr-0 mr-0 ml-0 pb-0 mb-0" }, [
                  _c("div", { staticClass: "row mt-2 maint-title" }, [
                    _c("div", { staticClass: "col-12 text-center" }, [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.$t("maintenanceSummaryTitle"))),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "row mt-2 legend justify-content-between align-items-center w-100 flex-nowrap p-0 m-0",
                    },
                    [
                      _c("div", { staticClass: "col-4 p-0" }, [
                        _c(
                          "div",
                          { staticClass: "col-4 text-right export-buttons" },
                          [
                            _vm.selectedView ===
                            _vm.maintenanceSummaryViews
                              .MAINTENANCE_SUMMARY_OVERVIEW
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.generatePmlTemplate()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("generatePMLTemplate")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.selectedView ===
                            _vm.maintenanceSummaryViews.FINANCIAL_VIEW
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportFinancialView()
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                                )
                              : _vm._e(),
                            _vm.selectedView ===
                            _vm.maintenanceSummaryViews.COMPONENTS_STRATEGY_VIEW
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportComponentsStrategy()
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "row flex-nowrap" }, [
                        _c("div", { staticClass: "row text-right pt-1 pr-5" }, [
                          _c("span", { staticClass: "legend-budget" }),
                          _c("p", [_vm._v(" " + _vm._s(_vm.$t("budgetVal")))]),
                        ]),
                        _c("div", { staticClass: "row text-left pt-1" }, [
                          _c("span", { staticClass: "legend-calculated" }),
                          _c("p", [
                            _vm._v(" " + _vm._s(_vm.$t("calculatedVal"))),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex col-4 p-0 justify-content-end align-items-center",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-8 text-right flex-nowrap" },
                            [
                              _vm.selectedView !==
                              _vm.maintenanceSummaryViews
                                .COMPONENTS_STRATEGY_VIEW
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "input-group input-group-sm mb-1",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("showTotalsFor"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.showPlannedTotals,
                                              expression: "showPlannedTotals",
                                            },
                                          ],
                                          staticClass:
                                            "custom-select custom-select-sm",
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.showPlannedTotals = $event
                                                  .target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                              function ($event) {
                                                return _vm.refresh(true)
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: false } },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("calculatedValues")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "option",
                                            { domProps: { value: true } },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("budgetValues")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedView,
                                      expression: "selectedView",
                                    },
                                  ],
                                  staticClass: "custom-select custom-select-sm",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedView = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      function ($event) {
                                        return _vm.onSelectedViewChanged()
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value:
                                          _vm.maintenanceSummaryViews
                                            .MAINTENANCE_SUMMARY_OVERVIEW,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("maintenanceSummaryTitle")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value:
                                          _vm.maintenanceSummaryViews
                                            .FINANCIAL_VIEW,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("financialView")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value:
                                          _vm.maintenanceSummaryViews
                                            .COMPONENTS_STRATEGY_VIEW,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("componentStrategyView")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-sm mt-1 filter-show maintenance-show simulation-btn",
                        attrs: {
                          type: "button",
                          id: "simulationButton",
                          "data-toggle": "modal",
                          "data-target": "#maintenanceSimulation",
                        },
                      },
                      [
                        _c("div", { staticClass: "content" }, [
                          _c(
                            "span",
                            [
                              _vm._v(" " + _vm._s(_vm.$t("simulation")) + " "),
                              _c("font-awesome-icon", {
                                attrs: { icon: "angle-right" },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "overflow-y-scroll summary-table pl-0 pr-3 pb-0 ml-0 mt-2",
                      attrs: { id: "vertical-scroll" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row pl-0 ml-0 maint-table-header" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-4 pl-0 ml-0 pr-0 freezeView" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-table-antet title table-antet",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "title1" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "angle-down" },
                                      }),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("plantArea")) + " "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "title2" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getCurrentViewMode(_vm.viewMode)
                                        ) + " "
                                      ),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "angle-right" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "col-8 pl-0 ml-0 pr-0" }, [
                            _vm.selectedView !==
                            _vm.maintenanceSummaryViews.COMPONENTS_STRATEGY_VIEW
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "summary-table-content-header",
                                    class: {
                                      yearsHeader:
                                        _vm.viewMode === _vm.viewModes.YEARS,
                                      monthsHeader:
                                        _vm.viewMode === _vm.viewModes.MONTHS,
                                    },
                                    style: {
                                      width:
                                        _vm.numOfCols * _vm.headerCellWidth +
                                        "px",
                                    },
                                  },
                                  _vm._l(
                                    _vm.tableHeader,
                                    function (item, index) {
                                      return _c("div", {
                                        key: "header-" + index,
                                        staticClass: "summary-table-header",
                                        style: {
                                          width: _vm.headerCellWidth + "px",
                                        },
                                        domProps: { innerHTML: _vm._s(item) },
                                      })
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            _vm.selectedView ===
                            _vm.maintenanceSummaryViews.COMPONENTS_STRATEGY_VIEW
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-table-content-header w-100 yearsHeader components-strategy-header",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "summary-table-header col",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("driver")) + " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "summary-table-header col",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("interval")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "summary-table-header col",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("pleLimit")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "summary-table-header col",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("cost")) +
                                              " (K" +
                                              _vm._s(_vm.getCurrencySymbol()) +
                                              ") "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-table-header col py-2",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("cost")) +
                                              " (K" +
                                              _vm._s(_vm.getCurrencySymbol()) +
                                              ") / EOH "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-table-header col py-2",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("duration")) +
                                              " (" +
                                              _vm._s(_vm.$t("days")) +
                                              ") "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-table-header col py-2",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("nextRevPlanned")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-table-header col py-2",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("nextRevCalculated")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "summary-table-content" }, [
                        _c(
                          "div",
                          { staticClass: "row summary-table-row pl-0 ml-0" },
                          [
                            _vm._l(
                              _vm.getPlantAreas(_vm.tableData.plantAreas),
                              function (plantArea, areaIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: "plantArea-" + areaIndex,
                                    staticClass:
                                      "plantArea col-12 pl-0 ml-0 mr-0 pr-0",
                                    style: {
                                      width:
                                        _vm.numOfCols * _vm.headerCellWidth +
                                        "px",
                                    },
                                    attrs: { id: "plantArea-" + areaIndex },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row pl-0 ml-0 pb-0 mb-0 pr-0 mr-0",
                                        style: {
                                          height: _vm.tableRowHeight + "px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row-border col-4 freezeView col-3-content text-ovflow-ellipsis pl-0 ml-0 pb-0 mb-0 pr-0 mr-0",
                                            style: {
                                              "background-color":
                                                areaIndex % 2 === 1
                                                  ? "#fff"
                                                  : "#f3f5f7",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "hidePlantItems",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.togglePlantItems(
                                                      "plantArea-" + areaIndex,
                                                      areaIndex
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticStyle: {
                                                    color: "#0078dc",
                                                  },
                                                  attrs: {
                                                    icon: "plus",
                                                    scale: "0.9",
                                                    id: "plus-" + areaIndex,
                                                  },
                                                }),
                                                _c("font-awesome-icon", {
                                                  staticStyle: {
                                                    color: "#0078dc",
                                                    display: "none",
                                                  },
                                                  attrs: {
                                                    icon: "minus",
                                                    scale: "0.9",
                                                    id: "minus-" + areaIndex,
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(plantArea.name) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-8 px-0 mx-0 pb-0 mb-0",
                                          },
                                          [
                                            _vm.selectedView ===
                                            _vm.maintenanceSummaryViews
                                              .MAINTENANCE_SUMMARY_OVERVIEW
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row-border area-totals-wrapper",
                                                      style: {
                                                        width:
                                                          _vm.numOfCols *
                                                            _vm.headerCellWidth +
                                                          "px",
                                                        height:
                                                          _vm.tableRowHeight +
                                                          "px",
                                                        "background-color":
                                                          areaIndex % 2 === 1
                                                            ? "#fff"
                                                            : "#f3f5f7",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "totals-inner-wrapper",
                                                        },
                                                        [
                                                          _vm._l(
                                                            plantArea.budgetMaintenanceItems,
                                                            function (
                                                              budget,
                                                              index
                                                            ) {
                                                              return [
                                                                _c("div", {
                                                                  key:
                                                                    "budget-" +
                                                                    index,
                                                                  staticClass:
                                                                    "budget-item",
                                                                  style: {
                                                                    width:
                                                                      budget.width +
                                                                      "px",
                                                                    left:
                                                                      budget.left +
                                                                      "px",
                                                                  },
                                                                  attrs: {
                                                                    type: "button",
                                                                    "data-toggle":
                                                                      "modal",
                                                                    "data-target":
                                                                      "#detailMaintenance",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.populateModal(
                                                                          budget,
                                                                          true,
                                                                          plantArea.id
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            }
                                                          ),
                                                          _vm._l(
                                                            plantArea.calculatedMaintenanceItems,
                                                            function (
                                                              calculated,
                                                              index
                                                            ) {
                                                              return [
                                                                _c("div", {
                                                                  key:
                                                                    "calculated" +
                                                                    index,
                                                                  staticClass:
                                                                    "calculated-item",
                                                                  style: {
                                                                    width:
                                                                      calculated.width +
                                                                      "px",
                                                                    left:
                                                                      calculated.left +
                                                                      "px",
                                                                  },
                                                                  attrs: {
                                                                    type: "button",
                                                                    "data-toggle":
                                                                      "modal",
                                                                    "data-target":
                                                                      "#detailMaintenance",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.populateModal(
                                                                          calculated,
                                                                          true,
                                                                          plantArea.id
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                      _vm._l(
                                                        _vm.yearLines,
                                                        function (year, index) {
                                                          return _c("div", {
                                                            key:
                                                              "yearline-" +
                                                              index,
                                                            staticStyle: {
                                                              "border-right":
                                                                "1px solid #cfd0d2",
                                                              width: "1px",
                                                              position:
                                                                "absolute",
                                                              top: "0",
                                                              bottom: "0",
                                                            },
                                                            style: {
                                                              left:
                                                                year *
                                                                  _vm.headerCellWidth *
                                                                  (_vm.viewMode ===
                                                                  _vm.viewModes
                                                                    .YEARS
                                                                    ? 1
                                                                    : _vm.viewMode ===
                                                                      _vm
                                                                        .viewModes
                                                                        .QUARTERS
                                                                    ? 4
                                                                    : 12) -
                                                                1 +
                                                                "px",
                                                            },
                                                          })
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm.selectedView ===
                                            _vm.maintenanceSummaryViews
                                              .FINANCIAL_VIEW
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row-border-bottom pt-0 pl-0 pb-0 pr-0",
                                                      style: {
                                                        width:
                                                          _vm.numOfCols *
                                                            _vm.headerCellWidth +
                                                          "px",
                                                        height:
                                                          _vm.tableRowHeight +
                                                          "px",
                                                        "background-color":
                                                          areaIndex % 2 === 1
                                                            ? "#fff"
                                                            : "#f3f5f7",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.tableHeader,
                                                      function (item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              "table-header-" +
                                                              index,
                                                            staticClass:
                                                              "financial-item",
                                                            style: {
                                                              width:
                                                                _vm.headerCellWidth +
                                                                "px",
                                                              height:
                                                                _vm.tableRowHeight +
                                                                "px",
                                                              "line-height":
                                                                _vm.tableRowHeight +
                                                                "px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "financial-item-number",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    plantArea
                                                                      .costsPerYear[
                                                                      item
                                                                    ]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm.selectedView ===
                                            _vm.maintenanceSummaryViews
                                              .COMPONENTS_STRATEGY_VIEW
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row-border-bottom d-inline-flex w-100 p-0",
                                                      style: {
                                                        height:
                                                          _vm.tableRowHeight +
                                                          "px",
                                                        "background-color":
                                                          areaIndex % 2 === 1
                                                            ? "#fff"
                                                            : "#f3f5f7",
                                                      },
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "col components-view-item",
                                                      }),
                                                      _c("div", {
                                                        staticClass:
                                                          "col components-view-item",
                                                      }),
                                                      _c("div", {
                                                        staticClass:
                                                          "col components-view-item",
                                                      }),
                                                      _c("div", {
                                                        staticClass:
                                                          "col components-view-item",
                                                      }),
                                                      _c("div", {
                                                        staticClass:
                                                          "col components-view-item",
                                                      }),
                                                      _c("div", {
                                                        staticClass:
                                                          "col components-view-item",
                                                      }),
                                                      _c("div", {
                                                        staticClass:
                                                          "col components-view-item",
                                                      }),
                                                      _c("div", {
                                                        staticClass:
                                                          "col components-view-item",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "hideItems item-wrapper-collapsed",
                                      },
                                      _vm._l(
                                        plantArea.items,
                                        function (item, itemIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: "plantArea-" + itemIndex,
                                              staticClass:
                                                "row px-0 mx-0 pb-0 mb-0",
                                              style: {
                                                height:
                                                  _vm.tableRowHeight + "px",
                                                "background-color":
                                                  (itemIndex + areaIndex) %
                                                    2 ===
                                                  0
                                                    ? "#fff"
                                                    : "#f3f5f7",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-4 freezeView pl-0 ml-0 pb-0 mb-0 pr-0 mr-0 col-3-content row-border",
                                                  style: {
                                                    "background-color":
                                                      (itemIndex + areaIndex) %
                                                        2 ===
                                                      0
                                                        ? "#fff"
                                                        : "#f3f5f7",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "data pl-3 ",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-ovflow-ellipsis",
                                                          attrs: {
                                                            title: item.name,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.name
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-8 px-0 mx-0 mb-0 pb-0",
                                                },
                                                [
                                                  _vm.selectedView ===
                                                  _vm.maintenanceSummaryViews
                                                    .MAINTENANCE_SUMMARY_OVERVIEW
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row-border items-wrapper",
                                                            style: {
                                                              width:
                                                                _vm.numOfCols *
                                                                  _vm.headerCellWidth +
                                                                "px",
                                                              height:
                                                                _vm.tableRowHeight +
                                                                "px",
                                                              "background-color":
                                                                (itemIndex +
                                                                  areaIndex) %
                                                                  2 ===
                                                                0
                                                                  ? "#fff"
                                                                  : "#f3f5f7",
                                                            },
                                                          },
                                                          [
                                                            _vm._l(
                                                              item.budgetMaintenanceItems,
                                                              function (
                                                                budget,
                                                                index
                                                              ) {
                                                                return [
                                                                  _c("div", {
                                                                    key:
                                                                      "budget-" +
                                                                      index,
                                                                    staticClass:
                                                                      "budget-item",
                                                                    style: {
                                                                      width:
                                                                        budget.width +
                                                                        "px",
                                                                      left:
                                                                        budget.left +
                                                                        "px",
                                                                    },
                                                                    attrs: {
                                                                      type: "button",
                                                                      "data-toggle":
                                                                        "modal",
                                                                      "data-target":
                                                                        "#detailMaintenance",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.populateModal(
                                                                            budget,
                                                                            false,
                                                                            plantArea.id,
                                                                            false
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ]
                                                              }
                                                            ),
                                                            _vm._l(
                                                              item.calculatedMaintenanceItems,
                                                              function (
                                                                calculated,
                                                                index
                                                              ) {
                                                                return [
                                                                  _c("div", {
                                                                    key:
                                                                      "calculated-" +
                                                                      index,
                                                                    staticClass:
                                                                      "calculated-item",
                                                                    style: {
                                                                      width:
                                                                        calculated.width +
                                                                        "px",
                                                                      left:
                                                                        calculated.left +
                                                                        "px",
                                                                    },
                                                                    attrs: {
                                                                      type: "button",
                                                                      "data-toggle":
                                                                        "modal",
                                                                      "data-target":
                                                                        "#detailMaintenance",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.populateModal(
                                                                            calculated,
                                                                            false,
                                                                            plantArea.id,
                                                                            true
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ]
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                        _vm._l(
                                                          _vm.yearLines,
                                                          function (
                                                            year,
                                                            index
                                                          ) {
                                                            return _c("div", {
                                                              key:
                                                                "yearLine-" +
                                                                index,
                                                              staticStyle: {
                                                                "border-right":
                                                                  "1px solid #c8c8c8",
                                                                width: "1px",
                                                                position:
                                                                  "absolute",
                                                                top: "0",
                                                                bottom: "0",
                                                              },
                                                              style: {
                                                                left:
                                                                  year *
                                                                    _vm.headerCellWidth *
                                                                    (_vm.viewMode ===
                                                                    _vm
                                                                      .viewModes
                                                                      .YEARS
                                                                      ? 1
                                                                      : _vm.viewMode ===
                                                                        _vm
                                                                          .viewModes
                                                                          .QUARTERS
                                                                      ? 4
                                                                      : 12) -
                                                                  1 +
                                                                  "px",
                                                              },
                                                            })
                                                          }
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                  _vm.selectedView ===
                                                  _vm.maintenanceSummaryViews
                                                    .FINANCIAL_VIEW
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row-border-bottom p-0",
                                                            style: {
                                                              width:
                                                                _vm.numOfCols *
                                                                  _vm.headerCellWidth +
                                                                "px",
                                                              height:
                                                                _vm.tableRowHeight +
                                                                "px",
                                                              "background-color":
                                                                itemIndex %
                                                                  2 ===
                                                                0
                                                                  ? "#fff"
                                                                  : "#f3f5f7",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.tableHeader,
                                                            function (
                                                              year,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    "tableHeader-" +
                                                                    index,
                                                                  staticClass:
                                                                    "financial-item",
                                                                  style: {
                                                                    width:
                                                                      _vm.headerCellWidth +
                                                                      "px",
                                                                    "line-height":
                                                                      _vm.tableRowHeight +
                                                                      "px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item
                                                                          .costsPerYear[
                                                                          year
                                                                        ]
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                  _vm.selectedView ===
                                                  _vm.maintenanceSummaryViews
                                                    .COMPONENTS_STRATEGY_VIEW
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row-border-bottom d-inline-flex w-100 p-0",
                                                            style: {
                                                              height:
                                                                _vm.tableRowHeight +
                                                                "px",
                                                              "background-color":
                                                                (itemIndex +
                                                                  areaIndex) %
                                                                  2 ===
                                                                0
                                                                  ? "#fff"
                                                                  : "#f3f5f7",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col components-view-item px-0",
                                                                style: {
                                                                  "line-height":
                                                                    _vm.tableRowHeight +
                                                                    "px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.driverName
                                                                    ) +
                                                                    " "
                                                                ),
                                                                item.driver2Name
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " / " +
                                                                          _vm._s(
                                                                            item.driver2Name
                                                                          )
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col components-view-item px-0",
                                                                style: {
                                                                  "line-height":
                                                                    _vm.tableRowHeight +
                                                                    "px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getFormattedInterval(
                                                                        item.interval,
                                                                        item.driver
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                                item.interval2 &&
                                                                item.driver2
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " / " +
                                                                          _vm._s(
                                                                            _vm.getFormattedInterval(
                                                                              item.interval2,
                                                                              item.driver2
                                                                            )
                                                                          )
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col components-view-item px-0",
                                                                style: {
                                                                  "line-height":
                                                                    _vm.tableRowHeight +
                                                                    "px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getFormattedPleLimits(
                                                                        item
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col components-view-item px-0",
                                                                style: {
                                                                  "line-height":
                                                                    _vm.tableRowHeight +
                                                                    "px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.cost
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col components-view-item px-0",
                                                                style: {
                                                                  "line-height":
                                                                    _vm.tableRowHeight +
                                                                    "px",
                                                                },
                                                              },
                                                              [
                                                                item.driver ===
                                                                  _vm.drivers
                                                                    .EOH &&
                                                                item.interval
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            (
                                                                              item.cost /
                                                                              item.interval
                                                                            ).toFixed(
                                                                              4
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ])
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "N/A"
                                                                      ),
                                                                    ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col components-view-item px-0",
                                                                style: {
                                                                  "line-height":
                                                                    _vm.tableRowHeight +
                                                                    "px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.duration
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col components-view-item px-0",
                                                                style: {
                                                                  "line-height":
                                                                    _vm.tableRowHeight +
                                                                    "px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getNextRevisionDate(
                                                                        item.budgetMaintenanceItems
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col components-view-item px-0",
                                                                style: {
                                                                  "line-height":
                                                                    _vm.tableRowHeight +
                                                                    "px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getNextRevisionDate(
                                                                        item.calculatedMaintenanceItems
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              }
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.selectedView !==
                                      _vm.maintenanceSummaryViews
                                        .COMPONENTS_STRATEGY_VIEW,
                                    expression:
                                      "selectedView !== maintenanceSummaryViews.COMPONENTS_STRATEGY_VIEW",
                                  },
                                ],
                                staticClass:
                                  "col-12 px-0 ml-0 pb-0 mb-0 maint-table-footer",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row px-0 mx-0 pb-0 mb-0" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-4 freezeView px-0 ml-0 pb-0 mb-0 pos-sticky-div",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data pl-3 row-border days",
                                            style: {
                                              height: _vm.tableRowHeight + "px",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-ovflow-ellipsis",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("totalShutdown")
                                                    ) +
                                                    " (" +
                                                    _vm._s(_vm.$t("days")) +
                                                    ") "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data pl-3 row-border cost",
                                            style: {
                                              height: _vm.tableRowHeight + "px",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-ovflow-ellipsis mb-0",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("totalCost")
                                                    ) +
                                                    " " +
                                                    _vm._s(_vm.$t("opex")) +
                                                    " (K " +
                                                    _vm._s(
                                                      _vm.getCurrencySymbol()
                                                    ) +
                                                    ") "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data pl-3 row-border days",
                                            style: {
                                              height: _vm.tableRowHeight + "px",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-ovflow-ellipsis mb-0",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("totalCost")
                                                    ) +
                                                    " " +
                                                    _vm._s(_vm.$t("capex")) +
                                                    " (K " +
                                                    _vm._s(
                                                      _vm.getCurrencySymbol()
                                                    ) +
                                                    ") "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-8 px-0 ml-0 pb-0 mb-0",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "maint-table-content",
                                            style: {
                                              width:
                                                _vm.numOfCols *
                                                  _vm.headerCellWidth +
                                                "px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row pl-0 pr-0 md-0 ml-0 cell-row cell-row-2",
                                                style: {
                                                  width:
                                                    _vm.numOfCols *
                                                      _vm.headerCellWidth +
                                                    "px",
                                                  height:
                                                    _vm.tableRowHeight + "px",
                                                },
                                              },
                                              _vm._l(
                                                _vm.tableTotals,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "tableTotalsDuration-" +
                                                        index,
                                                      staticClass:
                                                        "maint-table-cell total-duration",
                                                      style: {
                                                        width:
                                                          _vm.granularityCoeficient *
                                                            _vm.headerCellWidth +
                                                          "px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.duration
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row pl-0 pr-0 md-0 ml-0 cell-row cell-row-2",
                                                style: {
                                                  width:
                                                    _vm.numOfCols *
                                                      _vm.headerCellWidth +
                                                    "px",
                                                  height:
                                                    _vm.tableRowHeight + "px",
                                                },
                                              },
                                              _vm._l(
                                                _vm.tableTotals,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "tableTotalsCost-" +
                                                        index,
                                                      staticClass:
                                                        "maint-table-cell total-cost",
                                                      style: {
                                                        width:
                                                          _vm.granularityCoeficient *
                                                            _vm.headerCellWidth +
                                                          "px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.opexCost
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row pl-0 pr-0 md-0 ml-0 cell-row cell-row-2",
                                                style: {
                                                  width:
                                                    _vm.numOfCols *
                                                      _vm.headerCellWidth +
                                                    "px",
                                                  height:
                                                    _vm.tableRowHeight + "px",
                                                },
                                              },
                                              _vm._l(
                                                _vm.tableTotals,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "tableTotalsCapex-" +
                                                        index,
                                                      staticClass:
                                                        "maint-table-cell total-duration",
                                                      style: {
                                                        width:
                                                          _vm.granularityCoeficient *
                                                            _vm.headerCellWidth +
                                                          "px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.capexCost
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]
                  ),
                  _vm.selectedView ===
                  _vm.maintenanceSummaryViews.MAINTENANCE_SUMMARY_OVERVIEW
                    ? _c(
                        "div",
                        {
                          staticClass: "zoom zoom2",
                          class: { bottonZoom: _vm.showZoom === true },
                          on: {
                            click: function ($event) {
                              _vm.showZoom = !_vm.showZoom
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "content" }, [
                            _c("span", [_vm._v(_vm._s(_vm.$t("zoom")))]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.selectedView ===
                  _vm.maintenanceSummaryViews.MAINTENANCE_SUMMARY_OVERVIEW
                    ? _c(
                        "div",
                        {
                          staticClass: "zoom-content",
                          class: { bottonZoom: _vm.showZoom === true },
                        },
                        [
                          _c("div", { staticClass: "rotate" }, [
                            _c("ul", { staticClass: "tooltip-inner-custom" }, [
                              _c(
                                "li",
                                {
                                  class: {
                                    selected_custom:
                                      _vm.viewMode === _vm.viewModes.YEARS,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.changeViewMode(_vm.viewModes.YEARS)
                                      _vm.showZoom = !_vm.showZoom
                                    },
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.$t("y")))])]
                              ),
                              _c(
                                "li",
                                {
                                  class: {
                                    selected_custom:
                                      _vm.viewMode === _vm.viewModes.QUARTERS,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.changeViewMode(_vm.viewModes.QUARTERS)
                                      _vm.showZoom = !_vm.showZoom
                                    },
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.$t("q")))])]
                              ),
                              _c(
                                "li",
                                {
                                  class: {
                                    selected_custom:
                                      _vm.viewMode === _vm.viewModes.MONTHS,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.changeViewMode(_vm.viewModes.MONTHS)
                                      _vm.showZoom = !_vm.showZoom
                                    },
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.$t("m")))])]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  tabindex: "-1",
                  role: "dialog",
                  "aria-hidden": "true",
                  id: "detailMaintenance",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog modal-dialog-centered",
                    attrs: { role: "document" },
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _vm.calculatedItemClicked
                          ? _c("h5", { staticClass: "modal-title" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("calculatedDetails")) + " "
                              ),
                            ])
                          : _vm._e(),
                        !_vm.calculatedItemClicked
                          ? _c("h5", { staticClass: "modal-title" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("budgetDetails")) + " "
                              ),
                            ])
                          : _vm._e(),
                        _vm._m(0),
                      ]),
                      _c(
                        "div",
                        { staticClass: "modal-body" },
                        [
                          _vm.modalData !== null
                            ? [
                                _c(
                                  "ul",
                                  [
                                    _c("li", [
                                      _c("strong", { staticClass: "title" }, [
                                        _vm._v(_vm._s(_vm.modalData.name)),
                                      ]),
                                    ]),
                                    _vm.modalData.maintenances &&
                                    _vm.modalData.maintenances.length > 0
                                      ? _vm._l(
                                          _vm.modalData.maintenances,
                                          function (item, index) {
                                            return _c(
                                              "li",
                                              { key: "maintenances-" + index },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.plant) +
                                                    " - " +
                                                    _vm._s(item.unit) +
                                                    " - " +
                                                    _vm._s(item.plantItem) +
                                                    ": " +
                                                    _vm._s(item.maintenance) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        )
                                      : _vm._e(),
                                    _c("li", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("duration")) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.modalData.duration) +
                                          " "
                                      ),
                                    ]),
                                    _c("li", [
                                      _c("strong", [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("cost")) + " "
                                        ),
                                        _vm.modalData.isOpex === true
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(_vm.$t("opex")) +
                                                  ")"
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.modalData.isOpex === false
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(_vm.$t("capex")) +
                                                  ")"
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(": "),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.modalData.cost) +
                                          "(K" +
                                          _vm._s(_vm.getCurrencySymbol()) +
                                          ") "
                                      ),
                                    ]),
                                    _c("li", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("startDate")) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              new Date(_vm.modalData.startDate),
                                              "YYYY-MM-DD"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("li", [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.$t("endDate")) + ":"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              new Date(_vm.modalData.endDate),
                                              "YYYY-MM-DD"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("li", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("leadingItem")) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.modalData.leadingItem === true
                                              ? _vm.$t("yes")
                                              : _vm.$t("no")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("li", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("outageId")) + ":"
                                        ),
                                      ]),
                                      _vm._v("  "),
                                      _vm.modalData.outageId !== "" &&
                                      _vm.modalData.outageId !== null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.modalData.outageId)
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.modalData.outageId === "" ||
                                      _vm.modalData.outageId === null
                                        ? _c("span", [_vm._v("N/A")])
                                        : _vm._e(),
                                    ]),
                                    _c("li", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("description")) + ":"
                                        ),
                                      ]),
                                      _vm._v("  "),
                                      _vm.modalData.desc !== "" &&
                                      _vm.modalData.desc !== null
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.modalData.desc)),
                                          ])
                                        : _vm._e(),
                                      _vm.modalData.desc === "" ||
                                      _vm.modalData.desc === null
                                        ? _c("span", [_vm._v("N/A")])
                                        : _vm._e(),
                                    ]),
                                    _vm.modalData.comment
                                      ? _c("li", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("comment")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.modalData.comment) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.modalData.groupData !== null
                                      ? _c("li", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.modalData.groupData
                                                  .groupLabel
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "  " +
                                              _vm._s(
                                                _vm.modalData.groupData
                                                  .groupItems
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm.objectHelper.propertyValueExists(
                                  _vm.modalData.details
                                )
                                  ? _c("ul", { staticClass: "mt-2" }, [
                                      _vm.calculatedItemClicked
                                        ? _c(
                                            "li",
                                            {
                                              staticStyle: {
                                                "border-bottom":
                                                  "1px solid #cdcdcd",
                                              },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("linkedBudgetItem")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.calculatedItemClicked
                                        ? _c(
                                            "li",
                                            {
                                              staticStyle: {
                                                "border-bottom":
                                                  "1px solid #cdcdcd",
                                              },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "linkedCalculatedItem"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("li", { staticClass: "title" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.modalData.details.name) +
                                            " "
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("duration")) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.modalData.details.duration
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.$t("cost")) + ":"),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.modalData.details.cost) +
                                            "(K" +
                                            _vm._s(_vm.getCurrencySymbol()) +
                                            ") "
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("startDate")) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("dateFormat")(
                                                new Date(
                                                  _vm.modalData.details.startDate
                                                ),
                                                "YYYY-MM-DD"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("endDate")) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("dateFormat")(
                                                new Date(
                                                  _vm.modalData.details.endDate
                                                ),
                                                "YYYY-MM-DD"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c("li", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("outageId")) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.modalData.details.outageId
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _vm.modalData.details.desc !== "" &&
                                      _vm.modalData.details.desc !== null
                                        ? _c("li", [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("description")) +
                                                  ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.modalData.details.desc
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  tabindex: "-1",
                  role: "dialog",
                  "aria-hidden": "true",
                  id: "maintenanceSimulation",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog modal-dialog-centered",
                    attrs: { role: "document" },
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c("h5", { staticClass: "modal-title" }, [
                          _vm._v(" " + _vm._s(_vm.$t("simulation")) + " "),
                        ]),
                        _vm._m(1),
                      ]),
                      _c("div", { staticClass: "modal-body pt-2 pb-2" }, [
                        _c("div", { staticClass: "row mt-1" }, [
                          _c("div", { staticClass: "col-4" }, [
                            _c("h5", [_vm._v(_vm._s(_vm.$t("bundle")))]),
                          ]),
                          _c("div", { staticClass: "col-8" }, [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group  btn-group-toggle",
                                attrs: { "data-toggle": "buttons" },
                              },
                              [
                                _vm._l(
                                  _vm.simulation.bundle,
                                  function (bundle, index) {
                                    return [
                                      _c(
                                        "label",
                                        {
                                          key: "bundle-" + index,
                                          class: [
                                            { active: bundle.selected },
                                            "btn",
                                            "btn-primary",
                                            "btn-sm",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectItem(
                                                _vm.simulation.bundle,
                                                bundle
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "radio",
                                              name: "options",
                                              id: "option" + bundle.id,
                                              autocomplete: "off",
                                            },
                                          }),
                                          _vm._v(
                                            " " + _vm._s(bundle.name) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mt-2" }, [
                          _c("div", { staticClass: "col-4" }, [
                            _c("h5", [_vm._v(_vm._s(_vm.$t("model")))]),
                          ]),
                          _c("div", { staticClass: "col-8" }, [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group btn-group-toggle",
                                attrs: { "data-toggle": "buttons" },
                              },
                              [
                                _vm._l(
                                  _vm.simulation.model,
                                  function (model, index) {
                                    return [
                                      _c(
                                        "label",
                                        {
                                          key: "model-" + index,
                                          class: [
                                            { active: model.selected },
                                            "btn",
                                            "btn-primary",
                                            "btn-sm",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectItem(
                                                _vm.simulation.model,
                                                model
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "radio",
                                              name: "options",
                                              id: "option" + model.id,
                                              autocomplete: "off",
                                            },
                                          }),
                                          _vm._v(
                                            " " + _vm._s(model.name) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "div",
                              { staticClass: "years-list mt-2" },
                              _vm._l(
                                _vm.simulation.years,
                                function (year, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "years-" + index,
                                      staticClass:
                                        "years-list-item ml-2 mt-1 mb-1",
                                    },
                                    [
                                      _c(
                                        "h6",
                                        { staticClass: "year mb-3 pl-5" },
                                        [_vm._v(" " + _vm._s(year.year) + " ")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "OH mb-2 input-group" },
                                        [
                                          _vm._m(2, true),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: year.operatingHours,
                                                expression:
                                                  "year.operatingHours",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            class: [
                                              {
                                                "is-invalid":
                                                  _vm.getValidateObject(
                                                    "simulation.years[" +
                                                      index +
                                                      "].operatingHours"
                                                  ),
                                              },
                                              "form-control",
                                            ],
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              placeholder: "OH",
                                              disabled:
                                                !_vm.simulationEnableYears,
                                            },
                                            domProps: {
                                              value: year.operatingHours,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  year,
                                                  "operatingHours",
                                                  _vm._n($event.target.value)
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "HS mb-2 input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group-prepend",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text hot-starts",
                                                  attrs: {
                                                    id:
                                                      "simulation-hs-" + index,
                                                  },
                                                },
                                                [_vm._v("HS")]
                                              ),
                                            ]
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: year.hotStarts,
                                                expression: "year.hotStarts",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            class: [
                                              {
                                                "is-invalid":
                                                  _vm.getValidateObject(
                                                    "simulation.years[" +
                                                      index +
                                                      "].hotStarts"
                                                  ),
                                              },
                                              "form-control",
                                            ],
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              placeholder: _vm.$t("hotStarts"),
                                              disabled:
                                                !_vm.simulationEnableYears,
                                            },
                                            domProps: { value: year.hotStarts },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  year,
                                                  "hotStarts",
                                                  _vm._n($event.target.value)
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "WS mb-2 input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group-prepend",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text warm-starts",
                                                  attrs: {
                                                    id:
                                                      "simulation-ws-" + index,
                                                  },
                                                },
                                                [_vm._v("WS")]
                                              ),
                                            ]
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: year.warmStarts,
                                                expression: "year.warmStarts",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            class: [
                                              {
                                                "is-invalid":
                                                  _vm.getValidateObject(
                                                    "simulation.years[" +
                                                      index +
                                                      "].warmStarts"
                                                  ),
                                              },
                                              "form-control",
                                            ],
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              placeholder: _vm.$t("warmStarts"),
                                              disabled:
                                                !_vm.simulationEnableYears,
                                            },
                                            domProps: {
                                              value: year.warmStarts,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  year,
                                                  "warmStarts",
                                                  _vm._n($event.target.value)
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "CS mb-2 input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group-prepend",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text cold-starts",
                                                  attrs: {
                                                    id:
                                                      "simulation-cs-" + index,
                                                  },
                                                },
                                                [_vm._v("CS")]
                                              ),
                                            ]
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: year.coldStarts,
                                                expression: "year.coldStarts",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            class: [
                                              {
                                                "is-invalid":
                                                  _vm.getValidateObject(
                                                    "simulation.years[" +
                                                      index +
                                                      "].coldStarts"
                                                  ),
                                              },
                                              "form-control",
                                            ],
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              placeholder: _vm.$t("coldStarts"),
                                              disabled:
                                                !_vm.simulationEnableYears,
                                            },
                                            domProps: {
                                              value: year.coldStarts,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  year,
                                                  "coldStarts",
                                                  _vm._n($event.target.value)
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "span",
                          {
                            staticClass: "wait",
                            class: {
                              "fade-in": _vm.waitingForSimulation === true,
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("pleaseWait")))]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.refreshSimulation()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("refresh")) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.resetSimulation()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("reset")) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary btn-sm",
                            attrs: { type: "button", "data-dismiss": "modal" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "filter-show",
                class: { "visible-button": _vm.filterVisible },
                on: {
                  click: function ($event) {
                    return _vm.toggleFilter()
                  },
                },
              },
              [
                _c("div", { staticClass: "content" }, [
                  _c(
                    "span",
                    [
                      _vm._v(" " + _vm._s(_vm.$t("filter")) + " "),
                      _c("font-awesome-icon", {
                        attrs: { icon: "angle-down" },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "filter-container pt-2 pb-2 pl-2 pr-2",
                class: [{ visible: _vm.filterVisible }],
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "max-height": "700px",
                      "overflow-x": "hidden",
                      "overflow-y": "auto",
                    },
                  },
                  [
                    _c("h6", [
                      _vm._v(
                        _vm._s(_vm.$t("plant")) + " / " + _vm._s(_vm.$t("unit"))
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.filter.plants, function (plant, index) {
                        return _c(
                          "div",
                          {
                            key: "plantFilter-" + index,
                            staticClass: "col-auto mb-2",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "form-check pl-0",
                                staticStyle: { "border-bottom": "1px solid" },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: plant.selected,
                                      expression: "plant.selected",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: index + "-plant-filter",
                                  },
                                  domProps: {
                                    checked: Array.isArray(plant.selected)
                                      ? _vm._i(plant.selected, null) > -1
                                      : plant.selected,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = plant.selected,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                plant,
                                                "selected",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                plant,
                                                "selected",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(plant, "selected", $$c)
                                        }
                                      },
                                      function ($event) {
                                        return _vm.onPlantFilterChange(
                                          $event,
                                          plant
                                        )
                                      },
                                    ],
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: index + "-plant-filter" },
                                  },
                                  [_c("strong", [_vm._v(_vm._s(plant.name))])]
                                ),
                              ]
                            ),
                            _c(
                              "ul",
                              { staticClass: "list-unstyled" },
                              _vm._l(plant.units, function (unit, unitIndex) {
                                return _c("li", { key: "unit-" + unitIndex }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-check pl-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: unit.selected,
                                            expression: "unit.selected",
                                          },
                                        ],
                                        staticClass: "form-check-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: unit.machineSID + "-unit-filter",
                                        },
                                        domProps: {
                                          checked: Array.isArray(unit.selected)
                                            ? _vm._i(unit.selected, null) > -1
                                            : unit.selected,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a = unit.selected,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      unit,
                                                      "selected",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      unit,
                                                      "selected",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(unit, "selected", $$c)
                                              }
                                            },
                                            function ($event) {
                                              return _vm.onUnitFilterChange(
                                                $event,
                                                plant,
                                                unit
                                              )
                                            },
                                          ],
                                        },
                                      }),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "form-check-label",
                                          attrs: {
                                            for:
                                              unit.machineSID + "-unit-filter",
                                          },
                                        },
                                        [_vm._v(_vm._s(unit.name))]
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c("hr", { staticClass: "mt-0 mb-1" }),
                    _c("h6", [_vm._v(_vm._s(_vm.$t("plantArea")))]),
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(
                        _vm.filter.plantAreas,
                        function (plantArea, index) {
                          return _c(
                            "div",
                            {
                              key: "plantAreaFilter-" + index,
                              staticClass: "col-auto mb-2",
                            },
                            [
                              _c("div", { staticClass: "form-check pl-0" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: plantArea.selected,
                                      expression: "plantArea.selected",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: plantArea.name + "-plant-area-filter",
                                  },
                                  domProps: {
                                    checked: Array.isArray(plantArea.selected)
                                      ? _vm._i(plantArea.selected, null) > -1
                                      : plantArea.selected,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = plantArea.selected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              plantArea,
                                              "selected",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              plantArea,
                                              "selected",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(plantArea, "selected", $$c)
                                      }
                                    },
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: {
                                      for:
                                        plantArea.name + "-plant-area-filter",
                                    },
                                  },
                                  [_vm._v(_vm._s(plantArea.name))]
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    _c("hr", { staticClass: "mb-1" }),
                    _c("h6", [_vm._v(_vm._s(_vm.$t("plantItem")))]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6 ml-1 mb-1" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter.plantItemName,
                              expression: "filter.plantItemName",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          domProps: { value: _vm.filter.plantItemName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.filter,
                                "plantItemName",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("hr", { staticClass: "mb-1" }),
                    _c("h6", [_vm._v(_vm._s(_vm.$t("maintenanceActivity")))]),
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(
                        _vm.filter.maintenanceActivities,
                        function (maintenanceActivity, index) {
                          return _c(
                            "div",
                            {
                              key: "maintenanceActivityFilter-" + index,
                              staticClass: "col-auto mb-2",
                            },
                            [
                              _c("div", { staticClass: "form-check pl-0" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: maintenanceActivity.selected,
                                      expression:
                                        "maintenanceActivity.selected",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "checkbox",
                                    id:
                                      maintenanceActivity.id +
                                      "-maintenance-type-filter",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      maintenanceActivity.selected
                                    )
                                      ? _vm._i(
                                          maintenanceActivity.selected,
                                          null
                                        ) > -1
                                      : maintenanceActivity.selected,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = maintenanceActivity.selected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              maintenanceActivity,
                                              "selected",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              maintenanceActivity,
                                              "selected",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          maintenanceActivity,
                                          "selected",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: {
                                      for:
                                        maintenanceActivity.id +
                                        "-maintenance-type-filter",
                                    },
                                  },
                                  [_vm._v(_vm._s(maintenanceActivity.name))]
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    _c("hr", { staticClass: "mb-2" }),
                    _c(
                      "div",
                      { staticClass: "input-group input-group-sm pb-2" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.$t("outageIds")) + ":"),
                          ]),
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.selectedOutageId,
                                expression: "filter.selectedOutageId",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filter,
                                  "selectedOutageId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                            ]),
                            _vm._l(_vm.filter.outageIds, function (id, index) {
                              return _c(
                                "option",
                                {
                                  key: "outageIdFilter-" + index,
                                  domProps: { value: id },
                                },
                                [_vm._v(" " + _vm._s(id) + " ")]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "input-group input-group-sm pb-2" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.$t("globalProjectId")) + ":"),
                          ]),
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.selectedGlobalProjectId,
                                expression: "filter.selectedGlobalProjectId",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filter,
                                  "selectedGlobalProjectId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                            ]),
                            _vm._l(
                              _vm.filter.globalProjectIds,
                              function (project, index) {
                                return _c(
                                  "option",
                                  {
                                    key: "globalIdFilter-" + index,
                                    domProps: { value: project },
                                  },
                                  [_vm._v(" " + _vm._s(project) + " ")]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "input-group input-group-sm pb-2" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.$t("maintenanceOrRiskId")) + ":"),
                          ]),
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.selectedMaintenanceOrRiskId,
                                expression:
                                  "filter.selectedMaintenanceOrRiskId",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filter,
                                  "selectedMaintenanceOrRiskId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                            ]),
                            _vm._l(
                              _vm.filter.maintenanceOrRiskIds,
                              function (maintenanceOrRiskId, index) {
                                return _c(
                                  "option",
                                  {
                                    key: "maintenanceRiskIdFilter-" + index,
                                    domProps: { value: maintenanceOrRiskId },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(maintenanceOrRiskId) + " "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]
                ),
                _c("hr"),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link btn-sm float-left",
                    on: {
                      click: function ($event) {
                        return _vm.clearAllFilters()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("clearAllFilters")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm mt-1",
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("filter")) + " ")]
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text", attrs: { id: "" } }, [
        _vm._v("OH"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }